import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Downloader1449And892 = () => {
  const faqs = [
    {
      question: "Q: What does '1449 & 892' feature do ?",
      answer:
        "A: This module allows you to download 1449 and 892 documents by simply entering a U.S. patent application number.",
    },
    {
      question:
        "Q: What are 1449 and 892 documents ?",
      answer:
        "A: 1449 is the applicant’s IDS listing prior art. 892 is the USPTO’s form listing examiner-cited references",
    },
    {
      question:
        "Q: Can the system download multiple forms (if exist) for a single application ?",
      answer:
        "A: Yes, if multiple 1449 or 892 forms exist for a single application whether issued on the same or different dates; JUNE will download all of them. If no such forms are available for the specified application, this will be clearly mentioned in the email notification sent to JUNE user.",
    },
    {
      question:
        "Q: How many applications can I enter at one time ?",
      answer:
        "A: Up to 100 applications can be entered at once.",
    },
     {
      question:
        "Q: Can I enter a US patent or publication number in JUNE ?",
      answer:
        "A: No. Only valid US application/serial numbers are accepted.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": { margin: 0 },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography sx={{ whiteSpace: "pre-line" }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default Downloader1449And892;
